/**
 * Removes year-related tokens from a format string.
 */
export function removeYearFromFormat(format: string) {
  return format.replace(/(yo|Yo|y|Y|R|u)+/g, '');
}
